import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import banner1 from '../assets/banner1.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";

export default function HomeBanner3(props) {

	const appContext = useContext(AppContext);
	const [ready, setReady] = useState(false);

	useEffect(() => {
		setReady(true);
	}, []);

	if (!ready) {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}

	return (
		<div 
			className="MainBodySection"
			style={{
				padding: "0",
				backgroundImage: `url(${banner1})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			}}
		>
			<div className="container">
				<div className="row">

					<div className="col-md-6" style={{ height: "300px" }} />

					<div className="col-md-6">
						<div
							style={{
								padding: "20px",
								marginTop: "30px",
								marginBottom: "30px",
								background: "rgba(255, 255, 255, 0.7)",
							}}
						>
							<h6 className="main-section-title">
								Why Choose TYIDI
								<span
									style={{
										display: "block",
										borderBottom: "3px solid var(--secondaryColor)",
										width: "50px",
										marginTop: "10px"
									}}
								/>
							</h6>

							{/* Item */}
							<div className="d-flex align-items-start mb-3">
								<IoMdCheckmarkCircleOutline
									size={32}
									style={{ flexShrink: 0, marginTop: "4px" }}
								/>
								<span
									className="font-bold"
									style={{
										fontSize: "16px",
										textTransform: "uppercase",
										paddingLeft: "10px"
									}}
								>
									Youth-led, community-driven development approach
								</span>
							</div>

							{/* Item */}
							<div className="d-flex align-items-start mb-3">
								<IoMdCheckmarkCircleOutline
									size={32}
									style={{ flexShrink: 0, marginTop: "4px" }}
								/>
								<span
									className="font-bold"
									style={{
										fontSize: "16px",
										textTransform: "uppercase",
										paddingLeft: "10px"
									}}
								>
									Strong focus on sustainable livelihoods and agriculture
								</span>
							</div>

							{/* Item */}
							<div className="d-flex align-items-start mb-3">
								<IoMdCheckmarkCircleOutline
									size={32}
									style={{ flexShrink: 0, marginTop: "4px" }}
								/>
								<span
									className="font-bold"
									style={{
										fontSize: "16px",
										textTransform: "uppercase",
										paddingLeft: "10px"
									}}
								>
									Proven grassroots experience in neglected communities
								</span>
							</div>

							{/* Item */}
							<div className="d-flex align-items-start mb-4">
								<IoMdCheckmarkCircleOutline
									size={32}
									style={{ flexShrink: 0, marginTop: "4px" }}
								/>
								<span
									className="font-bold"
									style={{
										fontSize: "16px",
										textTransform: "uppercase",
										paddingLeft: "10px"
									}}
								>
									Trusted partnerships with government and private sector
								</span>
							</div>

							<div className="text-end mt-4">
								<button
									className="btn btn-padded btn-rounded btn-primary"
									onClick={() =>
										appContext.navTo({ item: 'contact_us' })
									}
								>
									Contact Us
								</button>
							</div>

						</div>
					</div>

				</div>
			</div>
		</div>
	);
}
